(function () {
  'use strict';

  function factory() {
    'ngInject';

    var intesityMin = 400;
    var intesityMax = 1600;

    return {
      convert: convert,
      min: intesityMin,
      max: intesityMax,
    };

    function convert(intensity) {
      // Start value from zero
      var opacity = intensity - intesityMin;
      // Normalize to 0-1
      return opacity / intesityMax;
    }
  }

  angular
    .module('hq.tools.lighting')
    .factory('hqTLightingLumen', factory);
}());
